import { LiabilitiesData, RecordSnapshotRetrievalStrategy } from 'aven_types'
import { BasePersonalFinancialStatementResource, PersonalFinancialStatementResourceType } from './basePersonalFinancialStatementResource'
import { getLiabilitiesAsOfDate } from '../../../services/personalFinancialStatement'

export class PersonalFinancialStatementLiabilityResource extends BasePersonalFinancialStatementResource<PersonalFinancialStatementResourceType.LIABILITIES> {
    constructor() {
        super(PersonalFinancialStatementResourceType.LIABILITIES)
    }

    protected async fetchData(): Promise<LiabilitiesData> {
        const now = new Date()

        const response = await getLiabilitiesAsOfDate({
            snapshotDate: now,
            sourceUniqueId: null,
            retrievalStrategy: RecordSnapshotRetrievalStrategy.SINGLE_SOURCE_WATERFALL_HIGHEST_RECORD_COUNT,
            rateLimitingOptions: {
                turnOffRateLimiter: false,
                onlyCountSuccessfulFetchesWhenRateLimiting: true,
            },
            fetchNewRecordSnapshotsOptions: {
                doNotFetchNewRecordsFromSource: false,
                fetchKeyStatusesFromSourceValues: true,
            },
        })

        if (response.data.success) {
            return response.data.payload
        }

        return {
            creditCards: [],
            loans: [],
        }
    }
}
